import { ICustomerDetails } from './customer-details.interface';
import { IKeepingInTouchPreferences } from './keeping-in-touch-preferences';

export interface ICustomerDetailsPage {
  customerDetails: ICustomerDetails;
  preferences: IKeepingInTouchPreferences;
}
